<template>
    <!-- component -->
    <div class="min-h-screen flex justify-center">
        <div class="max-w-4xl w-full">
            <!-- box -->
            <template v-for="type in types">
                <inertia-link
                    :id="type.id"
                    v-if="type.est_visible"
                    :href="route('inscription.categories', type.slug)"
                    class="md:w-full flex-col md:flex-row min-h-34 flex m-2 bg-white border-2 border-gray-300 shadow-xs hover:shadow-md">
                    <img :alt="__(type.slug)"
                         class="md:w-60"
                         onerror="this.src='https://via.placeholder.com/240x158/FFFFFF/000000?text=Aucune image trouvée.'"
                         :src="type.image ? asset('images/types/'+type.image)  : 'https://via.placeholder.com/240x158/FFFFFF/000000?text=Aucune image trouvée.'"/>
                    <div class="flex flex-col m-3">
                        <h4 class="text-xl font-bold">{{ __(type.slug) }}</h4>
                        <p v-if="type.categories" class="text-xs uppercase text-gray-700">
                            <template v-for="(categorie, nb) in type.categories">
                                <span v-if="!nb">{{ __(categorie.slug) }}</span>
                                <span v-else> | {{ __(categorie.slug) }}</span>
                            </template>
                        </p>
                    </div>
                </inertia-link>
            </template>
            <!-- box -->
        </div>
    </div>
</template>

<script>
import App from '@/Layouts/App'

export default {
    name: "Types",
    layout: App,
    props: {
        types: Array,
    }
}
</script>

<style scoped>

</style>
